document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-sc-add]');
  if (!b) return;
  e.preventDefault();
  b.disabled = true; b.textContent = 'Agregando…';
  try {
    const drawer = document.querySelector('cart-drawer');
    const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.dataset.scAdd), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || 'error');
    if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
      data.id = Number(b.dataset.scAdd);
      drawer.renderContents(data);
      if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    } else { window.location.href = '/cart'; }
  } catch (err) { window.location.href = '/cart'; }
});
